module.exports = __webpack_public_path__ + "static/media/bicycle_3_complete_bicycle.e221b273.png";